.root {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.top {
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 360px) minmax(0, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.image {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 8px;
  display: flex;
  height: 280px;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}

.image-img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.image-placeholder {
  color: var(--color-muted);
}

.fields {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.field-value {
  align-items: center;
  display: flex;
  gap: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.description-html {
  color: var(--color-foreground);
  line-height: 1.6;

  p {
    margin: 0 0 12px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: var(--color-primary);
    text-decoration: underline;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 20px;
  }
}

.private-notes {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.private-notes-head {
  align-items: center;
  display: flex;
  gap: 6px;
}

.copy-button {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--color-muted);
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 2px;

  &:hover {
    background: var(--color-secondary);
    color: var(--color-foreground);
  }
}

.private-notes-body {
  background: var(--color-secondary);
  border-radius: 8px;
  color: var(--color-foreground);
  line-height: 1.6;
  padding: 12px;
  word-break: break-word;

  p {
    margin: 0 0 12px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: var(--color-primary);
    text-decoration: underline;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 20px;
  }
}

.attachments {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attachments-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
}

.attachment {
  aspect-ratio: 1;
  background: var(--color-secondary);
  border-radius: 8px;
  display: block;
  overflow: hidden;
}

.attachment-img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

// Facilities (legacy PreviewModal parity): a multi-column list of facility
// titles, each prefixed with a check icon.
.facilities {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.facilities-grid {
  display: grid;
  gap: 8px 16px;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}

.facility-item {
  align-items: center;
  color: var(--color-foreground);
  display: flex;
  gap: 6px;
  min-width: 0;
}

.facility-icon {
  color: var(--color-success-foreground);
  flex-shrink: 0;
}

.error {
  padding: 24px;
}
